module.exports = __webpack_public_path__ + "img/q31.764c6f03.png";